import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AutocompleteTagFilter from "./AutocompleteTagFilter";
import Select from "./Select";
import { AiOutlineMinus } from "react-icons/ai";

// shadcn
import { Card, CardHeader, CardTitle, CardContent } from "components/ui/card";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";

const simpleInputFields = [
  { label: "שם", field: "name" },
  { label: "פלאפון", field: "phone" },
  { label: "מוצר", field: "product" },
  { label: "הערות", field: "comments" },
];

const statusOptions = [
  { value: "all", label: "כל הסטטוסים" },
  { value: "pending", label: "ממתין" },
  { value: "inProgress", label: "בתהליך" },
  { value: "done", label: "הסתיים" },
];


const OrderFilter = ({ onFilter, setShowFilter }) => {
  const [filters, setFilters] = useState({
    name: "",
    phone: "",
    status: "",
    product: "",
    comments: "",
    startDate: null,
    endDate: null,
    tags: [],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = (selectedStatus) => {
    setFilters((prev) => ({ ...prev, status: selectedStatus }));
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setFilters((prev) => ({ ...prev, startDate: start, endDate: end }));
  };

  const handleTagChange = (selectedTags) => {
    setFilters((prev) => ({ ...prev, tags: selectedTags.map((t) => ({ ...t })) }));
  };

  const handleFilter = () => onFilter(filters);

  const handleReset = () => {
    const empty = {
      name: "",
      phone: "",
      status: "",
      product: "",
      comments: "",
      startDate: null,
      endDate: null,
      tags: [],
    };
    setFilters(empty);
    onFilter({});
  };

  const isFilterActive = (field) => {
    const v = filters[field];
    return Array.isArray(v) ? v.length > 0 : !!v;
  };

  return (
    <div className="w-full" dir="rtl">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">סינון הזמנות</h2>
        <Button variant="ghost" size="icon" onClick={() => setShowFilter(false)} aria-label="הסתר מסננים">
          <AiOutlineMinus />
        </Button>
      </div>

      <div className="mt-3 grid grid-cols-1 gap-3 md:grid-cols-2">
        {simpleInputFields.map((f) => (
          <div key={f.field} className="space-y-1">
            <Label htmlFor={f.field}>{f.label}</Label>
            <Input
              id={f.field}
              type="text"
              name={f.field}
              value={filters[f.field]}
              onChange={handleInputChange}
              className={isFilterActive(f.field) ? "bg-accent/40" : ""}
              placeholder={f.label}
            />
          </div>
        ))}

        {/* Status */}
        <div className="space-y-1">
          <Label>סטטוס</Label>
          <Select
            options={statusOptions}
            initialValue={filters.status}
            onOptionChange={handleStatusChange}
          />
        </div>

        {/* Date range */}
        <div className="space-y-1">
          <Label>טווח תאריכים</Label>
          <DatePicker
            selected={filters.startDate}
            onChange={handleDateChange}
            startDate={filters.startDate}
            endDate={filters.endDate}
            selectsRange
            isClearable
            placeholderText="בחר טווח תאריכים"
            className={`w-full rounded-md border bg-background px-3 py-2 text-sm ring-offset-background ${
              isFilterActive("startDate") || isFilterActive("endDate") ? "bg-accent/40" : ""
            }`}
          />
        </div>

        {/* Tags */}
        <div className="space-y-1 md:col-span-2">
          <Label>תגיות</Label>
          <AutocompleteTagFilter
            selectedTags={filters.tags}
            setSelectedTags={handleTagChange}
          />
        </div>
      </div>

      <div className="mt-4 flex flex-col gap-2 md:flex-row md:justify-between">
        <Button onClick={handleFilter} className="md:w-auto">סנן</Button>
        <Button onClick={handleReset} variant="secondary" className="md:w-auto">נקה</Button>
      </div>
    </div>
  );
};

export default OrderFilter;
